import isEmpty from 'lodash/isEmpty';
import uuid from 'uuid/v4';
import {
    editorMinWidgetCols,
    editorMinWidgetRows,
} from '../shared/constants/constants';
import { buildWidgetFilterState } from '../viewDashboards/dashboardLinkUtils';

// eslint-disable-next-line complexity
export function getFormattedWidget(view, widget, dashboardLabels) {
    const {
        filterValues,
        timeAndPrecision,
        whereClauses,
        panels,
        widgets,
        ...viewProps
    } = view;

    const { id, panelId, position, tabId, title, ...widgetProps } = widget;

    const panel = panels.find((x) => x.id === panelId);
    const tab = panel.tabs?.find((x) => x.id === tabId);

    const filterState = buildWidgetFilterState(
        timeAndPrecision,
        filterValues,
        whereClauses,
        widget
    );

    const stateData = {
        ...filterState,
        title,
    };

    const staticData = {
        ...viewProps,
        ...widgetProps,
        additionalFilterKeys: isEmpty(widget.additionalFilterKeys)
            ? view.additionalFilterKeys
            : widget.additionalFilterKeys,
        availableFilterKeys: isEmpty(widget.availableFilterKeys)
            ? view.availableFilterKeys
            : widget.availableFilterKeys,
        availableFilters: isEmpty(widget.availableFilters)
            ? view.availableFilters
            : widget.availableFilters,
        isDescending: widget.isDescending
            ? !!view.isDescending
            : !!widget.isDescending,
        recordLimit: widget.recordLimit ? view.recordLimit : widget.recordLimit,
        requiredFilterKeys: isEmpty(widget.requiredFilterKeys)
            ? view.requiredFilterKeys
            : widget.requiredFilterKeys,
        whereClauseOptions: isEmpty(widget.whereClauseOptions)
            ? view.whereClauseOptions
            : widget.whereClauseOptions,
    };

    return {
        dashboardKey: view.dashboardKey,
        dashboardTitle: view.title,
        panelTitle: panel.header,
        stateData,
        staticData,
        tabTitle: tab?.label,
        viewKey: view.viewKey,
        viewTitle: dashboardLabels[view.viewKey] ?? view.viewKey,
    };
}

export function getDashboardViewKey(dashboardKey, viewKey) {
    return `${dashboardKey}${viewKey ? `-${viewKey}` : ''}`;
}

export function createDraggableWidget(widget, x, y) {
    const id = uuid();
    return {
        ...widget,
        id,
        x,
        y,
        i: id,
        w: editorMinWidgetCols,
        h: editorMinWidgetRows,
        minW: editorMinWidgetCols,
        minH: editorMinWidgetRows,
    };
}

export function onWidgetDrag(event, widget, setDraggingWidget) {
    event.dataTransfer.setData('text/plain', '');
    event.dataTransfer.setDragImage(
        event.target,
        window.outerWidth,
        window.outerHeight
    );

    setDraggingWidget(createDraggableWidget(widget));
}
